import React, { useEffect, useRef, useState } from 'react'
import { addquantitiesbatch, deleteInvalidProductQuantity, deleteProductQuantity, getFilteredQuantities, getProductQuantities, getInvalidProductQuantities } from '../../services/product-quantity-service';
import CustomBreadcrumb from '../common/CustomBreadcrumb';
import Alert from '../common/Alert';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import ResponsiveTable from '../Grid/ResponsiveTable';
import deleteIcon from '../../assets/delete.svg';
import InputBox from '../common/InputBox';
import ExcelDownload from '../Grid/ExcelDownload';
import withReactContent from "sweetalert2-react-content";
import Swal from 'sweetalert2';
import constants from "../../helpers/constants";
import { formatDateTime } from "../../helpers/date-formatter";
import ProductQtyForm from './ProductQtyForm';
import Loader from '../common/loader';
import { validateAlphaNumeric } from '../../helpers/validations';

export default function ProductQtyMaster() {

  const MySwal = withReactContent(Swal);
  const [action, setAction] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState({});
  const [reload, setReload] = useState(false);
  const [error, setError] = useState({});
  const [errorMessage, setErrorMessage] = useState();
  const [data, setData] = useState([]);
  const dataRef = useRef([]);
  const [uploadResult, setUploadResult] = useState(null);
  const [invalidData, setInvalidData] = useState([]);
  const [invalidHeaders, setInvalidHeaders] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(() => {
    return localStorage.getItem('uploadLoading') === 'true';
  });

  const setUploadLoadingWithStorage = (loading) => {
    setUploadLoading(loading);
    localStorage.setItem('uploadLoading', loading.toString());
  };
  const [productObj, setProductObj] = useState({
    gadCustomerCode: "",
    retailerGstin: "",
    productCode: "",
    billedQty: "",
    alreadyConsumedQty: "",
    regularConsumedQty: "",
    balanceQty: "",
  });

  const handleReset = () => {
    setProductObj({
      gadCustomerCode: "",
      retailerGstin: "",
      productCode: "",
      billedQty: "",
      alreadyConsumedQty: "",
      regularConsumedQty: "",
      balanceQty: "",
    });
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductObj((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  const [headers] = useState([
    { displayName: "GAD Customer Code", columnName: "gadCustomerCode", dataType: "text", width: 220, maxLength:50, displayIndication: true, required: true, upload: true },
    { displayName: "Retailer GSTIN", columnName: "retailerGstin", dataType: "text", width: 180, maxLength:50, displayIndication: true, required: true, upload: true },
    { displayName: "Product Code", columnName: "productCode", dataType: "text", width: 180, maxLength:50, displayIndication: true, required: true, upload: true, 
      duplicateCheck: (productCode, rowObj) => {
        return dataRef.current.some((item) => 
          item.productCode?.toLowerCase() === productCode?.toString().toLowerCase() && 
          item.gadCustomerCode?.toLowerCase() === rowObj?.gadCustomerCode?.toString().toLowerCase() &&
          item.retailerGstin?.toLowerCase() === rowObj?.retailerGstin?.toString().toLowerCase()
        );
      }
    },
    { displayName: "Billed Quantity", columnName: "billedQty", dataType: "text", width: 180, displayIndication: true, required: true, upload: true },
    { displayName: "Updated By", columnName: "createdById", dataType: "text", width: 180, maxLength:50, displayIndication: true },
    { displayName: "Updated On", columnName: "createdOn", dataType: "date", width: 180, displayIndication: true, formatter: formatDateTime },
    { displayName: "Already Consumed Quantity", columnName: "alreadyConsumedQty", dataType: "text", width: 240, displayIndication: true, required: true, upload: true },
    { displayName: "Regular Consumed Quantity", columnName: "regularConsumedQty", dataType: "text", width: 240, displayIndication: true, required: true, upload: true },
    { displayName: "Balance Quantity", columnName: "balanceQty", dataType: "text", width: 200, displayIndication: true, required: true, upload: true },
  ]);

  const handleAdd = () => {
    setAction("Add");
    setShowForm(true);
  };

  useEffect(() => {
      getQuantity();
      getInvalidQuantities();
      setError();
    }, [reload]);

  useEffect(() => {
    const checkUploadStatus = () => {
      const storageValue = localStorage.getItem('uploadLoading') === 'true';
      if (storageValue !== uploadLoading) {
        setUploadLoading(storageValue);
      }
    };
    
    const interval = setInterval(checkUploadStatus, 100);
    return () => clearInterval(interval);
  }, [uploadLoading]);



  const getQuantity = async () => {
    setLoading(true)
    let result = await getProductQuantities().catch((error) => Alert("error", error))
    if (result) {
      setData(result)
      dataRef.current = result;
    }
    setLoading(false)
  }

  const getInvalidQuantities = async () => {
    try {
      // Replace with your actual API call to get invalid records
      const result = await getInvalidProductQuantities();
      if (result && result.length > 0) {
        setInvalidData(result);
        const headersWithError = [...headers, { displayName: "Error", columnName: "Error", dataType: "text", displayIndication: true, width: 150 }];
        setInvalidHeaders(headersWithError);
      } else {
        setInvalidData([]);
        setInvalidHeaders([]);
      }
    } catch (error) {
      console.log("Error fetching invalid data:", error);
      setInvalidData([]);
      setInvalidHeaders([]);
    }
  }

  const getFilteredQuantity = async () =>{
    setLoading(true)
    const isUserObjEmpty = Object.values(productObj).every(value => value === "");
    if(isUserObjEmpty){
      await getQuantity()
    }else{
      let result = await getFilteredQuantities(productObj).catch((error) => Alert("error", error))
      if (result) {
        if(result.length === 0){
          Alert("info", "No data found")
        }
        setData(result)
    }
  }
    setLoading(false)
  }

  let icons = [{ src: deleteIcon, click: del, iconName: "Delete" }]

  function del(item) {
    setRowData(item);

    let confirmationMessage = "Are you sure do you want to Delete Selected Product Quantity?";
    let title = "Delete Product Quantity";

    MySwal.fire({
        title: title,
        html: confirmationMessage,
        ...constants.CONFIRMATION_BOX_CONFIG
      })
      .then(async (selection) => {
        if (selection.isConfirmed) {
            setLoading(true)
            let result;

            result = await deleteProductQuantity(item).then((resp) => {
                Alert("success", "Product Quantity deleted successfully")
                setShowForm(false);
                setReload(!reload);
            }).catch((err) => {
                setLoading(false)
            })
        }
    });
}

const validateQuantity = (value) => {
  let isError = "";
  let pattern = /^[0-9]*$/;
  let regex = new RegExp(pattern);
  if (!regex.test(value)) {
      isError = `Please enter a Valid Number`;
      setErrorMessage(isError)
  }
  else{
      isError = ``
      setErrorMessage("")
  }
  return isError;
}

const handleApi = async()=>{
  console.log("inside handleApi");
   await deleteInvalidProductQuantity();
}



const handleUpload = async (data) => {
    try {
      console.log("inside handleUpload data",data);
      
      // Store invalid data for download button
      if (data.invalidData && data.invalidData.length > 0) {
        setInvalidData(data.invalidData);
        // Create headers with Error column for invalid data
        const headersWithError = [...headers, { displayName: "Error", columnName: "Error", dataType: "text", displayIndication: true, width: 150 }];
        setInvalidHeaders(headersWithError);
      } else {
        setInvalidData([]);
        setInvalidHeaders([]);
      }
     
      const result = await addquantitiesbatch(data);
      console.log("inside handleUpload result", result);
      setUploadResult(result);
      setReload(!reload);
      return result;
    } catch (error) {
      throw error;
    }
  };


  const commonProps = { setError: setError, error: error, onChange: handleChange }

  return (
    <>
        {loading && <Loader/>}    

      {showForm && (
        <ProductQtyForm
          show={showForm}
          action={action}
          rowdata={rowData}
          setReload={() => setReload(!reload)}
          productdata={data}
          onHide={() => setShowForm(false)}
        />
      )}

      <CustomBreadcrumb parentMenu={"Maintenance"} menu={"Maintain Product Quantity"}> </CustomBreadcrumb>
      <Container bsPrefix="main-body drop-down">
        <div className="page-title">Product Quantity Master</div>
        <Row>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="GAD Customer Code" name="gadCustomerCode" value={productObj.gadCustomerCode} customValidation= {validateAlphaNumeric} {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Retailer GSTIN" name="retailerGstin" value={productObj.retailerGstin} customValidation= {validateAlphaNumeric} {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Product Code" name="productCode" value={productObj.productCode} customValidation= {validateAlphaNumeric} {...commonProps} />
          </Col>
          <Col lg={3} md={12} className="txt-input">
            <InputBox type="text" label="Billed Quantity" name="billedQty" value={productObj.billedQty} {...commonProps} customValidation={validateQuantity} />
          </Col>
        </Row>
        <Row className='mb-2'>
          <Col lg={4} md={12} className="txt-input">
            <InputBox type="text" label="Already Consumed Quantity" name="alreadyConsumedQty" value={productObj.alreadyConsumedQty} {...commonProps} customValidation={validateQuantity} />
          </Col>
          <Col lg={4} md={12} className="txt-input">
            <InputBox type="text" label="Regular Consumed Quantity" name="regularConsumedQty" value={productObj.regularConsumedQty} {...commonProps} customValidation={validateQuantity} />
          </Col>
          <Col lg={4} md={12} className="txt-input">
            <InputBox type="text" label="Balance Quantity" name="balanceQty" value={productObj.balanceQty} {...commonProps} customValidation={validateQuantity} />
          </Col>
        </Row>
        <Row className='mb-2'>
          <Col className="display-action-btn">
            <Button onClick={handleReset} className="btn btn-outline-primary reset-button" variant="outline-primary">Reset</Button>
            <Button onClick={getFilteredQuantity} className="btn btn-primary btn-color btn-go">Go</Button>
            {invalidData.length > 0 && (
              <Button 
                className="btn btn-secondary ms-2 btn-color"
                onClick={() => {
                  const hiddenDownloadBtn = document.querySelector('.invalid-excel-download img');
                  if (hiddenDownloadBtn) {
                    hiddenDownloadBtn.click();
                  }
                }}
              >
                Download Invalid Records
              </Button>
            )}
            <div style={{display: 'none'}} className="invalid-excel-download">
              <ExcelDownload 
                fileName={`Invalid_Quantities`} 
                downloadData={true} 
                headers={invalidHeaders} 
                data={invalidData} 
              />
            </div>
          </Col>
        </Row>

        <ResponsiveTable headers={headers} data={data} icons={icons} DisplayExcelDownload={true} dataType={"Quantities"} button={"New Quantity"} handleAdd={handleAdd} sessionName={"Maintain Product Quantity"} handleUpload={handleUpload} setReload={setReload} reload={reload} pageSize={5} productdata={data} handleApi={handleApi} uploadLoading={uploadLoading} setUploadLoading={setUploadLoadingWithStorage} invalidData={invalidData} invalidHeaders={invalidHeaders}></ResponsiveTable>
      </Container>
    </>
  )
}
